const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001/api/v1';

export const API_ENDPOINTS = {
  // Authentication
  AUTH: {
    LOGIN: `${API_BASE_URL}/auth/login`,
    REFRESH_TOKEN: `${API_BASE_URL}/account/refresh-token`,
  },

  // User Management
  USERS: {
    LIST: `${API_BASE_URL}/users`,
    CREATE: `${API_BASE_URL}/users`,
    GET_BY_ID: id => `${API_BASE_URL}/users/${id}`,
    UPDATE: id => `${API_BASE_URL}/users/${id}`,
    DELETE: id => `${API_BASE_URL}/users/${id}`,
    BULK_DELETE: `${API_BASE_URL}/users/bulk-delete`,
    EXPORT: `${API_BASE_URL}/users/export`,
  },

  // Profile Management
  PROFILE: {
    GET: `${API_BASE_URL}/profile`,
    UPDATE: `${API_BASE_URL}/profile`,
    UPLOAD_AVATAR: `${API_BASE_URL}/profile/avatar`,
    DELETE_AVATAR: `${API_BASE_URL}/profile/avatar`,
  },

  // Dashboard & Analytics
  DASHBOARD: {
    STATS: `${API_BASE_URL}/dashboard/stats`,
    ANALYTICS: `${API_BASE_URL}/dashboard/analytics`,
    RECENT_ACTIVITIES: `${API_BASE_URL}/dashboard/activities`,
  },

  // Content Management
  CONTENT: {
    POSTS: `${API_BASE_URL}/content/posts`,
    CATEGORIES: `${API_BASE_URL}/content/categories`,
    TAGS: `${API_BASE_URL}/content/tags`,
    MEDIA: `${API_BASE_URL}/content/media`,
    UPLOAD: `${API_BASE_URL}/content/upload`,
  },

  // Settings
  SETTINGS: {
    GENERAL: `${API_BASE_URL}/settings/general`,
    SECURITY: `${API_BASE_URL}/settings/security`,
    NOTIFICATIONS: `${API_BASE_URL}/settings/notifications`,
    INTEGRATIONS: `${API_BASE_URL}/settings/integrations`,
  },

  // Notifications
  NOTIFICATIONS: {
    LIST: `${API_BASE_URL}/notifications`,
    MARK_READ: id => `${API_BASE_URL}/notifications/${id}/read`,
    MARK_ALL_READ: `${API_BASE_URL}/notifications/read-all`,
    DELETE: id => `${API_BASE_URL}/notifications/${id}`,
  },

  // Audit Logs
  AUDIT: {
    LOGS: `${API_BASE_URL}/audit/logs`,
    EXPORT: `${API_BASE_URL}/audit/export`,
  },
};
